import { Flex, Radio, Tabs, Button } from "antd"
import { spacings } from "themes/variables"
import { useState } from "react"
import CustomDrawer from "ui/Drawer"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import styles from "./index.module.css"

const FilterSortDrawer = ({
  open,
  setOpen,
  setSortField,
  setSortOrder,
  selectedGroup,
  setSelectedGroup,
  sortBy,
  setSortBy,
  groups = [],
  fetchClients,
  searchBy
}) => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState("filters")

  const renderRightAlignedRadioList = (items, selectedValue, onChange) => (
    <Flex vertical gap={spacings.M}>
      {items.map(({ label, value }) => (
        <Flex justify="space-between" align="middle" key={value} onClick={() => onChange(value)} style={{ cursor: "pointer" }}>
          <Text>{label}</Text>
          <Radio checked={selectedValue === value} />
        </Flex>
      ))}
    </Flex>
  )

  const tabItems = [
    {
      key: "filters",
      label: "Filters",
      children: (
        <Flex vertical gap={spacings.M}>
          <Text variant="sub" fw="500">
            Select Group
          </Text>
          {renderRightAlignedRadioList(
            [
              { label: t("clients.all_groups"), value: "all" },
              ...groups.map((group) => ({
                label: group.name,
                value: String(group.id)
              }))
            ],
            selectedGroup,
            setSelectedGroup
          )}
        </Flex>
      )
    },
    {
      key: "sorting",
      label: "Sorting",
      children: (
        <Flex vertical gap={spacings.M}>
          <Text variant="sub" fw="500">
            Sort by
          </Text>
          {renderRightAlignedRadioList(
            [
              { label: t("clients.sort_by_name_asc"), value: "nameAsc" },
              { label: t("clients.sort_by_name_desc"), value: "nameDesc" },
              { label: t("clients.sort_by_ytd_spent_asc"), value: "ytdHigh" },
              { label: t("clients.sort_by_ytd_spent_desc"), value: "ytdLow" }
            ],
            sortBy,
            setSortBy
          )}
        </Flex>
      )
    }
  ]

  const handleApplyClick = () => {
    setOpen(false)
    let nextSortField, nextSortOrder
    if (sortBy === "nameAsc") {
      nextSortField = "sort_by_user_full_name"
      nextSortOrder = "ascend"
    } else if (sortBy === "nameDesc") {
      nextSortField = "sort_by_user_full_name"
      nextSortOrder = "descend"
    } else if (sortBy === "ytdHigh") {
      nextSortField = "sort_by_total_booking_amount"
      nextSortOrder = "descend"
    } else if (sortBy === "ytdLow") {
      nextSortField = "sort_by_total_booking_amount"
      nextSortOrder = "ascend"
    }
    setSortField(nextSortField)
    setSortOrder(nextSortOrder)

    // Always reset to first page on filter/sort
    if (selectedGroup && selectedGroup !== "all") {
      fetchClients(searchBy, selectedGroup, false, 1, nextSortField, nextSortOrder)
    } else {
      fetchClients(searchBy, null, false, 1, nextSortField, nextSortOrder)
    }
  }

  return (
    <CustomDrawer open={open} setOpen={setOpen} title="Filters & Sorting" className={"mobileOnly"}>
      <Flex vertical gap={spacings.XL} className="px-m">
        <Tabs
          className={styles.mobileCenteredFilters}
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          tabBarStyle={{ marginBottom: spacings.M }}
          centered
        />
        <Button type="primary" block className="py-l mt-xl" onClick={handleApplyClick}>
          Apply
        </Button>
      </Flex>
    </CustomDrawer>
  )
}

FilterSortDrawer.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  setSortField: PropTypes.func,
  setSortOrder: PropTypes.func,
  selectedGroup: PropTypes.string,
  setSelectedGroup: PropTypes.func,
  sortBy: PropTypes.string,
  setSortBy: PropTypes.func,
  groups: PropTypes.array,
  fetchClients: PropTypes.func,
  searchBy: PropTypes.string
}

export default FilterSortDrawer
